<template>
  <v-dialog v-model="model" :max-width="maxWidth" :persistent="persistent">
    <v-card>
      <v-card-title class="headline" primary-title>{{ title }}</v-card-title>
      <v-card-text style="font-size: 17px" v-if="description">{{ description }}
        <input type="date"
               style="width: 140px;font-size: 17px"
               id="from"
               name="exportCsvFrom"
               :value="exportDateFrom"
               @input="$emit('updateDateFrom',$event.target.value)"/>
        <div style="margin-left: 252px">
        to
        <input type="date"
               style="width: 140px;font-size: 17px"
               id="to"
               name="exportCsvTo"
               :value="exportDateTo"
               @input="$emit('updateDateTo',$event.target.value)"/>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error darken-1" flat @click.native="$emit('export')">Export CSV</v-btn>
        <v-btn color="secondary" flat @click.native="$emit('cancel')">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'MPayTransactionExportLimitDialog',

  props: {
    show: { type: Boolean, required: true },
    title: { type: String, required: true },
    description: { type: String, required: false },
    exportDateFrom: { type: String, required: false },
    exportDateTo: { type: String, required: false },
    persistent: { type: Boolean, required: false, default: false },
    maxWidth: { type: String, required: false, default: '500px' },
  },

  data: () => ({}),

  computed: {
    model: {
      get() {
        return this.show;
      },
      set(newValue) {
        if (!newValue) {
          this.$emit('cancel');
        }
      },
    },
  },

};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MPayTransactionExportLimitDialog.vue